import { Icon, IconName } from '@ets/design-system';
import { FormattedMessage } from 'react-intl';

type ReferencePriorityCellProps = {
  object: Objekt;
  value: string;
};

const ICON_NAMES: Record<'medium' | 'high' | 'low', IconName> = {
  medium: 'equals',
  high: 'chevron-up',
  low: 'chevron-down',
};

const ICON_COLORS: Record<'medium' | 'high' | 'low', 'warning' | 'error' | 'success'> = {
  medium: 'warning',
  high: 'error',
  low: 'success',
};

const ReferencePriorityCell = ({ object, value }: ReferencePriorityCellProps) => {
  const referenceValue = value.split('.');

  return (
    <div style={{ display: 'flex' }}>
      <Icon
        icon={ICON_NAMES[referenceValue[0] as 'medium' | 'high' | 'low'] ?? 'equals'}
        size="3"
        color={ICON_COLORS[referenceValue[0] as 'medium' | 'high' | 'low'] ?? 'warning'}
        testId={`${referenceValue[0].charAt(0).toUpperCase()}${referenceValue[0].slice(1)}`}
      />
      <span style={{ marginLeft: '1rem' }}>
        <FormattedMessage
          id="NUMBER_OF_REFERENCES"
          values={{
            number: object.reference_priority?.[referenceValue[0]]?.[referenceValue[1]],
          }}
        />
      </span>
    </div>
  );
};

export default ReferencePriorityCell;
